import { useState } from 'react'
import { Group, MathUtils } from 'three'

import { useLevelGeometry, useOutlineExclusion, useTerrainMask } from '@hooks'

import { useGroundControls } from '@utils'
import { Bushes } from './Bushes'
import { Flowers } from './Flowers'
import { Grass } from './Grass'
import { Pebbles } from './Pebbles'
import { Trees } from './Trees'

// Frozen at module load so the terrain doesn't regenerate on HMR.
// const SEED = Math.random() * 1000
const SEED = 1042689007

interface TerrainGroundProps {
  seed?: number
}

export function Ground({ seed = SEED }: TerrainGroundProps) {
  const { base, grass, flowers, trees, pebbles, bushes, maxCount } = useGroundControls()

  const [group, setGroup] = useState<Group | null>(null)
  useOutlineExclusion(group)

  const { size } = useLevelGeometry()
  const padding = size.fullWidth - size.visibleWidth + 1
  const side = Math.max(size.visibleWidth + padding, size.height + padding)
  const mask = useTerrainMask(side, seed, 1.5)

  return (
    <group ref={setGroup}>
      {base && (
        <mesh position-x={size.centerOffset} receiveShadow rotation-x={MathUtils.degToRad(-90)}>
          <planeGeometry args={[side, side]} />
          <meshLambertMaterial color={0xffffff} map={mask.groundTexture} />
        </mesh>
      )}
      {grass && (
        // <ZoomDetailed thresholds={[100]}>
        <Grass mask={mask} groundTexture={mask.groundTexture} maxCount={maxCount} />
        // <Grass mask={mask} seed={seed} count={30000} planes={1} />
        // </ZoomDetailed>
      )}
      {flowers && <Flowers mask={mask} />}
      {trees && <Trees mask={mask} />}
      {pebbles && <Pebbles mask={mask} />}
      {bushes && <Bushes mask={mask} />}
    </group>
  )
}
